import { React, useState, useEffect, Fragment } from "react";
import { toast } from "react-toastify";
import InfiniteScroll from "react-infinite-scroll-component";
import moment from "moment";
import { Icon } from "@iconify/react";
import DownloadIcon from "@mui/icons-material/Download";
import { Grid, Box } from "@mui/material";
import "./ChatRoomBody.css";
import ModalMediaOld from "./ModalMediaOld";
import CampaignDetailForm from "../Contact/CampaignDetailForm";
import renderBody from "../Helper/renderBody";
import Forward from "../Images/Forward.svg";
import { getContactDetail } from "../Store/Actions/ChatAction";

function ChatRoomBody({
  message,
  MfetchData,
  mhasMore,
  GenerateNonPopUpFiles,
  statusSender,
  downloadOut,
  clearMedia,
  separator,
  openModalMedia,
  selectedName,
  Media,
  Video,
  id,
  showCampaignDetail,
  detailchat,
  isApp,
  getmedia,
}) {
  const [getDate, setGetDate] = useState(message[0].time);
  const [campaigndetail, setCampaigndetail] = useState([]);
  const [campaigndetailName, setCampaigndetailName] = useState({});
  let scrollTimer = null;

  useEffect(() => {
    //Get Stickers and Audio
    // GenerateNonPopUpFiles(message, id?.Session);
    GenerateNonPopUpFiles(message, detailchat?.Session);
  }, [message]);

  useEffect(() => {
    const getCampaignDetail = async () => {
      const response = await getContactDetail(
        detailchat?.CampaignID,
        detailchat?.OutboundContactID,
        detailchat?.AssignmentID
      );
      if (response.status) {
        let campaigndetailArray = [];
        const contactdetail = response.data.CampaignDetail && response.data.CampaignDetail[0];
        for (var key in contactdetail) {
          if (contactdetail.hasOwnProperty(key)) {
            campaigndetailArray.push({
              key: key,
              value: contactdetail[key],
            });
          }
        }
        setCampaigndetail(campaigndetailArray);
        setCampaigndetailName(response.data.Campaign);
      } else {
        toast.warn(response.error);
      }
    };
    if (!showCampaignDetail && detailchat?.CampaignID) getCampaignDetail();
    const renderDateFLoat = () => {
      const messageBox = document.getElementById("scrollableDiv1");
      let dateFloat = document.getElementsByClassName("DateFloat");
      if (dateFloat.length > 0) dateFloat = dateFloat[0];
      const scrollEvent = (box) => {
        dateFloat.style.top = "0vh";
        dateFloat.style.opacity = 1;

        clearTimeout(scrollTimer);

        scrollTimer = setTimeout(() => {
          dateFloat.style.top = "-2vh";
          dateFloat.style.opacity = 0;
        }, 2000);

        const dateLabels = document.querySelectorAll(".DateSeparator");
        let currentLabel = null;
        let boxR = box.getBoundingClientRect();
        dateLabels.forEach((dateLabel, idx, arr) => {
          let dlR = dateLabel.getBoundingClientRect();
          if (dlR.top > boxR.top) {
            currentLabel = idx >= dateLabels.length ? arr[idx] : arr[idx + 1];
          } else if (idx === 0) {
            currentLabel = arr[idx];
          }
        });
        if (currentLabel) {
          let el = currentLabel.getElementsByClassName("DateSeparatorVal");
          if (el && el.length > 0) setGetDate(el[0].innerText);
        } else {
        }
      };

      messageBox.removeEventListener("scroll", () => {
        scrollEvent(messageBox);
      });

      messageBox.addEventListener("scroll", () => {
        scrollEvent(messageBox);
      });
    };
    renderDateFLoat();
  }, []);

  const handleDownloadOut = (item) => {
    return (
      <div className="ChatRoombBody_DownloadOut">
        {item.type !== "chat" &&
        item.type !== "null" &&
        item.type !== "sticker" &&
        item.type !== "ptt" ? (
          <DownloadIcon
            style={{
              width: 16,
              height: 16,
              cursor: "pointer",
            }}
            onClick={() => downloadOut(item.FileName, item.caption, item.type)}
          ></DownloadIcon>
        ) : (
          ""
        )}
      </div>
    );
  };

  return (
    <div className="ChatRoombBody" id="chatroom">
      <div
        className={
          isApp() ? "campaigndetailContainerInApp" : "campaigndetailContainer"
        }
        style={{ display: !showCampaignDetail ? "none" : "flex" }}
      >
        <div className="CampaignDetailContent_Header_Container">
          <div className="CampaignDetailContent_Header">
            <Icon
              icon="mdi:clipboard-text-multiple-outline"
              color="#727272"
              width="24"
              height="24"
              style={{ marginRight: "12px" }}
            />
            Campaign Detail
          </div>
          <div className="CampaignDetailContent_SubHeader">
            <Icon
              icon="material-symbols:flag"
              color="#727272"
              width="20"
              height="20"
              style={{ marginRight: "4px" }}
            />
            {campaigndetailName.CampaignName}
            {campaigndetailName.SubCampaign
              ? " - " + campaigndetailName.SubCampaign
              : ""}
          </div>
        </div>
        <div className="CampaignDetailContent_Body_Container">
          <div className="campaignDetailScroller">
            <Box mt={1}>
              <Grid container spacing={1} pb={1}>
                {campaigndetail.map((item) => {
                  return (
                    <Grid item xs={12} sm={12} md={6} lg={4} key={item.key}>
                      <CampaignDetailForm item={item} />
                    </Grid>
                  );
                })}
              </Grid>
            </Box>
          </div>
        </div>
      </div>

      <div className="ContatinerChatRoomBody">
        {separator(
          "datefloat",
          moment.utc(getDate).format("DD MMM YYYY"),
          moment.utc(getDate).add(1, "d").format("DD MMM YYYY")
        )}
        {/* --------------------------------------------------------- */}
        <div className="listContainer" id="scrollableDiv1">
          <ModalMediaOld
            open={openModalMedia}
            fName={selectedName}
            media={Media}
            video={Video}
            onClose={clearMedia}
          />
          <InfiniteScroll
            dataLength={message.length}
            next={() => MfetchData()}
            style={{ display: "flex", flexDirection: "column-reverse" }}
            inverse={true}
            hasMore={mhasMore}
            scrollableTarget="scrollableDiv1"
          >
            {message.map((item, index, array) => {
              return (
                <Fragment key={item.RecordID}>
                  <div>
                    {id ? separator(index, item.FromMe) : ""}
                    <div
                      className={
                        item.FromMe === false
                          ? "ChatRoombBody_message"
                          : "ChatRoombBody_receiver"
                      }
                    >
                      <div className="ChatRoombBody_grid">
                        {item.isForwarded === 1 ? (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <div>
                              <img
                                alt=""
                                src={Forward}
                                style={{ width: 12, height: 12 }}
                              ></img>
                              <span className="ChatRoombBody_forwarded">
                                Forwarded
                              </span>
                            </div>
                            {handleDownloadOut(item)}
                          </div>
                        ) : (
                          handleDownloadOut(item)
                        )}
                        <span
                          className={
                            item.FromMe === false
                              ? "ChatRoombBody_name"
                              : "ChatRoombBody_nameReceiver"
                          }
                        >
                          {item.senderName}
                        </span>
                        {renderBody(
                          item.RecordID,
                          item.Body,
                          item.type,
                          item.FileName,
                          item.caption,
                          item.quotedMsgBody,
                          false,
                          getmedia
                        )}
                        <div className="ChatRoombBody_left">
                          <div className="ChatRoombBody_flex">
                            <span className="ChatRoombBody_timestamp">
                              {moment.utc(item.time).format("HH:mm")}
                            </span>

                            {item.FromMe === true
                              ? statusSender(item.StatusName)
                              : ""}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {separator(
                    "dateseparator",
                    moment.utc(item.time).format("DD MMM YYYY"),
                    index >= message.length - 1
                      ? moment.utc(item.time).add(-1, "d").format("DD MMM YYYY")
                      : moment.utc(array[index + 1].time).format("DD MMM YYYY")
                  )}
                </Fragment>
              );
            })}
          </InfiniteScroll>
        </div>
      </div>
    </div>
  );
}

export default ChatRoomBody;
